import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { BOTTOM_TABBAR_HEIGHT, DEFAULT_MARGIN, MAX_WINDOW_WIDTH, Z_INDEX } from '@constants/layout';
import { Layout, Typo } from '@design-system';
import { AnimatedToastBarContainer, AnimationState } from './ToastBar.styled';

interface ToastBarProps {
  text: string;
  bottom?: number;
  RightComponent?: ReactNode;
  closeToastBar?: () => void;
  timeout?: number;
}

export default function ToastBar({
  text,
  bottom = BOTTOM_TABBAR_HEIGHT + 16,
  RightComponent,
  closeToastBar,
  timeout = 3000,
}: ToastBarProps) {
  const [animationState, setAnimationState] = useState<AnimationState>('show');

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState('hide');
      setTimeout(() => {
        closeToastBar?.();
      }, 500);
    }, timeout);

    return () => {
      clearTimeout(timer);
    };
  }, [closeToastBar, timeout]);

  return createPortal(
    <Layout.Absolute
      z={Z_INDEX.TOAST_CONTAINER}
      b={bottom}
      l="50%"
      r={0}
      w="100%"
      tl={['-50%', 0]}
      justifyContent="center"
    >
      <AnimatedToastBarContainer
        state={animationState}
        justifyContent={RightComponent ? 'space-between' : 'center'}
        bgColor="LIGHT_GRAY"
        rounded={12}
        ph={12}
        pv={16}
        w={`calc(100vw - ${2 * DEFAULT_MARGIN}px)`}
        style={{ maxWidth: `${MAX_WINDOW_WIDTH - 2 * DEFAULT_MARGIN}px` }}
      >
        <Typo color="DARK_GRAY" type="body-large" pre>
          {text}
        </Typo>
        {RightComponent && RightComponent}
      </AnimatedToastBarContainer>
    </Layout.Absolute>,
    document.getElementById('toast-container') || document.body,
  );
}
